import web3NoAccount from "./web3";
import GemsLockingABI from "./GemsLockingABI.json";
import GemsStakingABI from "./GemsStakingABI.json";
import GemsTokenABI from "./gemsTokenABI.json";
import StakingABI from "./StakingAbi.json";
import ChinaAbi from "./chinaAbi.json";
import LeiaAbi from "./leiaAbi.json";
import stackcontractGems from "../utils/StakingGemsAbi.json";
import stackcontractDop from "../utils/StakingDopAbi.json";
import DopAbi from "./dopClaimAbi.json";
import GemsSubscription from "./GemsSubscriptionABI.json";
import dopDynamicAbi from "./dopDynamicAbi.json";
import luckifyAbi from "./luckifyAbi.json";

import tomiContract from "../utils/tomiAbi2.json";
import uniswapAbi from "../utils/uniswap.json";
import nodeMiner from "./nodeMinerAbi.json";
import minerInsurance from "./minerInsuranceAbi.json";

import GemsStaking1 from "./gemsStackingAbi1.json";
import CreditRefund from "./CreditRefundABI.json";

import Rain from "./rainAbi.json";
import Vesting from "./vestingAbi.json";
import AstraNovaRewards from "./AstraNovaRewards.json";
const getContract = (abi, address, web3) => {
  const _web3 = web3 ?? web3NoAccount;
  return new _web3.eth.Contract(abi, address);
};

export const chinaContract = (address, web3) => {
  return getContract(ChinaAbi, address, web3);
};

export const dopContract = (address, web3) => {
  return getContract(DopAbi, address, web3);
};

export const dopDynamicContract = (address, web3) => {
  return getContract(dopDynamicAbi, address, web3);
};

export const luckifyContruct = (address, web3) => {
  return getContract(luckifyAbi, address, web3);
};

export const leiaContract = (address, web3) => {
  return getContract(LeiaAbi, address, web3);
};
export const getGemsLockingContract = (address, web3) => {
  return getContract(GemsLockingABI, address, web3);
};
export const getGemsStakingContract = (address, web3) => {
  return getContract(GemsStakingABI, address, web3);
};
export const getGemsTokenContract = (address, web3) => {
  return getContract(GemsTokenABI, address, web3);
};

export const getStackContract = (address, web3) => {
  return getContract(StakingABI, address, web3);
};

export const getStackGemsContract = (address, web3) => {
  return getContract(stackcontractGems, address, web3);
};

export const getStackDopContract = (address, web3) => {
  return getContract(stackcontractDop, address, web3);
};

export const getuniSwapRouter = (address, web3) => {
  return getContract(uniswapAbi, address, web3);
};

export const getTomiContract = (address, web3) => {
  return getContract(tomiContract, address, web3);
};

export const nodeMinerContract = (address, web3) => {
  return getContract(nodeMiner, address, web3);
};

export const minerInsuranceContract = (address, web3) => {
  return getContract(minerInsurance, address, web3);
};

// export const getGemsStakingContract = (address, web3) => {
//   return getContract(GemsStaking1, address, web3);
// };
export const getGemsSubscriptionContract = (address, web3) => {
  return getContract(GemsSubscription, address, web3);
};

export const getCreditRefundContract = (address, web3) => {
  return getContract(CreditRefund, address, web3);
};

export const getRainContract = (address, web3) => {
  return getContract(Rain, address, web3);
};

export const getVestingContract = (address, web3) => {
  return getContract(Vesting, address, web3);
};
export const getAstraNovaRewardsContract = (address, web3) => {
  return getContract(AstraNovaRewards, address, web3);
};